<template lang="pug">
div
  apexchart(
    v-if="showChart"
    type="area",
    :options="options",
    :series="series"
  )
</template>

<script>
import { apiGet } from '../util/general'
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'c_referral_custom_chart',
  props: ['uuid'],
  data() {
    return {
      isLoading: true,
      showChart: false,
      series: [
      ],
      options: {
        colors: ['#70C9BB'],
        stroke: {
          show: true,
          curve: 'smooth',
          width: 3
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
            shade: 'light'
          },
          opacity: [1, 0]
        },
        dataLabels: {
          enabled: false
        },
        chart: {
          foreColor: '#373d3f',
          type: 'area',
          zoom: {
            enabled: true
          },
          toolbar: {
            tools: {
              download: false,
              reset: '<i class="fa fa-arrow-right"></i>'
            },
            autoSelected: 'pan'
          }
        },
        xaxis: {
          labels: {
            offsetY: -2,
            datetimeUTC: false
          },
          categories: [],
          type: 'datetime',
          min: 0
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        legend: {
          offsetY: 10,
          itemMargin: {
            vertical: 5
          }
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        tooltip: {
          x: {
            format: 'yyyy-MM-dd HH:mm'
          }
        }
      }
    }
  },
  components: {
    'apexchart': VueApexCharts
  },
  computed: {
    mode() {
      return this.$store.getters.mode
    }
  },
  mounted() {
    let vm = this
    vm.fetch()
  },
  methods: {
    fetch() {
      let vm = this

      vm.isLoading = true
      let url = '/v5/account/' + vm.uuid + '/referral/reports'

      let obj = {}
      apiGet(vm, url, obj, function (data) {
        if (!data.success) {
          vm.$store.dispatch('notifyError', data.msg)
        } else {
          let chartSeries = []
          let values = data.data.chart.data
          let timestamps = data.data.chart.timestamps
          let minDate = data.data.chart.timestamps[0]

          vm.options.fill.gradient.shade = vm.mode === 'dark' ? 'dark' : 'light'
          vm.options.xaxis.categories = timestamps
          vm.options.xaxis.min = minDate
          vm.options.chart.foreColor = vm.mode === 'dark' ? '#ffffff' : '#373d3f'

          chartSeries.push({
            name: 'Active Miners',
            data: values
          })

          vm.series = chartSeries

          vm.showChart = true
        }
      }, function (err) {
        vm.$store.dispatch('notifyError', err.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// c_referral_custom_chart.vue?1e145bfb